import { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUserReturnedFromUpiApp } from '../redux/appConfigInfo';

const useDetectWebPageVisibility = (onReturnCallback = () => {}) => {
  const dispatch = useDispatch();
  
  // Access the global payment state
  const { isWaitingForUpiApp } = useSelector((state) => state.appConfigInfo);
  
  const wasHidden = useRef(false);

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'hidden') {
      // Triggered when user leaves browser for UPI app
      wasHidden.current = true;
    } else if (document.visibilityState === 'visible' && wasHidden.current) {
      // Triggered when user returns
      wasHidden.current = false;

      if (isWaitingForUpiApp) {
        // 1. Update global state to "Verifying"
        dispatch(setUserReturnedFromUpiApp(true));
        
        // 2. Trigger the callback (usually a thunk or API call)
        if (onReturnCallback) {
          onReturnCallback();
        }
      }
    }
  }, [isWaitingForUpiApp, dispatch, onReturnCallback]);

  useEffect(() => {
    // Only listen if Redux says we are actually in a payment flow
    if (isWaitingForUpiApp) {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isWaitingForUpiApp, handleVisibilityChange]);
};

export default useDetectWebPageVisibility;